const ApiErrorCode = {
  0: "Success",
  1: "An unexpected server error occurred. Please try again later.",
  2: "Your session has expired. Please log in again.",
  3: "Authentication failed. Invalid token provided.",
  4: "The requested record could not be found.",
  5: "The request could not be processed due to invalid input.",
  6: "This record already exists.",

  1001: "Email address is required.",
  1002: "No account found with the provided ID.",
  1003: "Email does not exists.",
  1004: "Current password is incorrect.",
  1006: "Refresh token is required to continue.",
  1008: "Please upload an image.",
  1017: "The password you entered is incorrect.",
  1018: "Your current password is required.",

  2001: "Title is required.",
  2002: "Content is required.",
  2003: "Message is required.",
  2004: "Invalid status value.",
  2005: "Country selection is required.",
  2006: "Reason is required.",
  2007: "Code is required.",
  2008: "The uploaded file is not a valid image.",
  2009: "A list of users is required.",
  2010: "Disposable or temporary email addresses are not allowed.",
  2011: "You are not authorized to perform this action.",
  2012: "Name is required.",
  2013: "Invalid type provided.",
  2014: "Role ID is required.",
  2015: "Access ID is required.",
  2016: "Permissions are required.",
  2017: "Access list is required.",
};

export const getApiMessage = (code) => {
  return ApiErrorCode[code] || "Something went wrong";
};
